import * as React from "react";
import { styled } from "@mui/material";
import SummaryAssesmentListItem from "fe-web-components/patientCard/SummaryAssesmentListItem";
import {
  PatientSummaryPossibleCause,
  PatientSummaryProblemList,
  SummaryProblemProblem,
} from "fe-common/graphql";
import { KahunTitleCard } from "fe-web-components/layout/kahunTitleCard";
import { useMemo } from "react";
import { AGE, GENDER, Relations, Values } from "shared";

//region [[ Styles ]]
export const PatientCardHeader = styled("div")({
  fontSize: "14px",
  lineHeight: "15px",
  fontWeight: 600,
  color: "#243443",
  marginBottom: "12px",
});

const AssessmentHeader = styled(PatientCardHeader)({
  display: "flex",
  marginRight: "auto",
});

const AssessmentColumns = styled("div")({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
});

const DiseaseList = styled(KahunTitleCard)({
  flex: 1,
  height: "fit-content",
});

const ProblemList = styled(KahunTitleCard)({
  flex: 3.2,
  height: "fit-content",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientCardCreateAssesmentProps {
  dd: PatientSummaryPossibleCause[];
  problemList: PatientSummaryProblemList[];
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientCardCreateAssesment = ({
  dd,
  problemList,
}: PatientCardCreateAssesmentProps) => {
  const isNormalLevel = (qf: SummaryProblemProblem) =>
    qf.qualifiers.some(
      (q) => q.relation.id === Relations.LEVEL && q.value.id === Values.NORMAL,
    );
  //remove age and gender
  const cleanProblemList = useMemo(
    () =>
      problemList.filter(
        (p) =>
          p.problem.feature.id !== AGE &&
          p.problem.feature.id !== GENDER &&
          !isNormalLevel(p.problem),
      ),
    [problemList],
  );

  return (
    <AssessmentColumns className={"assessment-columns"}>
      <DiseaseList className={"disease-list"}>
        <AssessmentHeader className={"assessment-header"}>
          Diseases
        </AssessmentHeader>
        {dd.length > 0 &&
          dd.map((cause, index) => (
            <SummaryAssesmentListItem
              key={index}
              qf={cause.title}
              icd={cause.icd}
            />
          ))}
      </DiseaseList>
      <ProblemList className={"problem-list"}>
        <AssessmentHeader className={"assessment-header"}>
          Problem List
        </AssessmentHeader>
        {cleanProblemList.length > 0 &&
          cleanProblemList.map((problem, index) => (
            <SummaryAssesmentListItem
              key={index}
              qf={problem.problem}
              icd={problem.icd}
            />
          ))}
      </ProblemList>
    </AssessmentColumns>
  );
};
